import { jsx as _jsx } from "react/jsx-runtime";
import styles from './CancelIcon.module.scss';
import cn from 'classnames';
const CancelIcon = ({ onClick, className, type = 1, testId }) => {
    return (_jsx("span", { "data-testid": "cancelIcon1", onClick: onClick, className: cn(styles.element, className, styles[`hasType-${type}`]) }));
};
export default CancelIcon;
